import {
  GetPaymentSettingsResponse,
  GetPaymentSettingsForCheckoutResponse,
} from './src/service-plugins-types.js';
import {
  GetPaymentSettingsEnvelope,
  GetPaymentSettingsForCheckoutEnvelope,
} from './src/interfaces-ecommerce-v1-payment-settings-provider.public.js';

export * from './src/service-plugins-types';
export { GetPaymentSettingsEnvelope, GetPaymentSettingsForCheckoutEnvelope };

/**
 * This method retrieves payment settings from your app.
 *
 * Wix calls this method during the payment process. For example, when a customer inserts credit card details and places an order.
 * This method retrieves the payment settings to apply, and Wix passes on the settings to the payment provider.
 */
export declare function getPaymentSettings(
  payload: GetPaymentSettingsEnvelope
): GetPaymentSettingsResponse | Promise<GetPaymentSettingsResponse>;
/** Returns payment settings for provided Checkout entity. */
export declare function getPaymentSettingsForCheckout(
  payload: GetPaymentSettingsForCheckoutEnvelope
):
  | GetPaymentSettingsForCheckoutResponse
  | Promise<GetPaymentSettingsForCheckoutResponse>;
